<template>
  <el-select v-model="tempData" :placeholder="companyId === 'all' ? '请选择' : '请先选择厂商'"
             @change="change" :style="`width: ${width}`" :disabled="disabled" :clearable="clearable" filterable>
    <el-option v-for="item in list" :label="item.name" :value="item.name" :key="item.id"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "ModelSelect",
    model: {
      event: 'change',
    },
    props: {
      clearable: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      width: {
        type: String,
        default: "100%",
      },
      companyId: {
        type: [Number, String],
        default: "",
      },
      value: [String, Number],
    },
    data() {
      return {
        tempData: this.value,
        list: []
      }
    },
    created() {
      this.companyId && this.getList();
    },
    watch: {
      value(val) {
        this.tempData = val;
      },
    },
    methods: {
      async getList() {
        let nv = {
          page: 1,
          limit: 1000,
          company_id: this.companyId,
        };
        this.companyId === "all" && delete nv.company_id;
        let res = await this.$Http.getModelOption(nv);
        if (res?.data) {
          this.list = res.data || [];
        }
      },
      change(val) {
        const item = this.list.find(item => item.name === val);
        this.$emit('change', val, item)
      }
    }
  }
</script>

<style scoped>

</style>
